"use client";

import React, { useEffect, useState } from "react";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface StatData {
  label: string;
  value: number;
  suffix: string;
}
const statsData: StatData[] = [{
  label: "Years of Experience",
  value: 29,
  suffix: ""
}, {
  label: "Founded",
  value: 2004,
  suffix: ""
}, {
  label: "Cases Resolved",
  value: 1000,
  suffix: "+"
}];
function AnimatedStat({
  stat,
  "data-index": dataIndex
}: {
  stat: StatData;
  "data-index": number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.5
  });
  const [currentValue, setCurrentValue] = useState(0);
  const [progressValue, setProgressValue] = useState(0);
  useEffect(() => {
    if (isVisible) {
      const duration = 2000;
      const startTime = performance.now();
      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const progressRatio = Math.min(elapsed / duration, 1);
        const easeOut = 1 - Math.pow(1 - progressRatio, 3);
        setCurrentValue(Math.floor(easeOut * stat.value));
        setProgressValue(easeOut * 100);
        if (progressRatio < 1) {
          requestAnimationFrame(animate);
        } else {
          setCurrentValue(stat.value);
          setProgressValue(100);
        }
      };
      requestAnimationFrame(animate);
    }
  }, [isVisible, stat.value]);
  return <div ref={ref} data-index={dataIndex} className="relative flex flex-col items-center justify-center p-8 text-center border border-primary/20 bg-secondary/30 backdrop-blur-md">
      {}
      <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-primary/40"></div>
      <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-primary/40"></div>
      <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-primary/40"></div>
      <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-primary/40"></div>

      <div className="mb-4 flex items-baseline justify-center">
        <span className="font-default text-6xl md:text-7xl font-bold tracking-tighter bg-gradient-to-br from-primary to-primary/60 bg-clip-text text-transparent">
          {currentValue}
        </span>
        <span className="font-default text-4xl md:text-5xl font-bold text-primary ml-1">
          {stat.suffix}
        </span>
      </div>

      <div className="w-full max-w-[200px] mb-6">
        <Progress value={progressValue} className="h-0.5 bg-primary/10" />
      </div>

      <h3 className="font-default text-lg md:text-xl font-medium text-primary/80 uppercase tracking-widest">
        {stat.label}
      </h3>
    </div>;
}
export default function GeorgiaInfrastructureImpact() {
  return null;
}